module.exports = __webpack_public_path__ + "static/media/sub-banner.884f06bb.jpg";